const STORAGE_KEY = 'returnTo';

const AUTH_PATHS = ['/login', '/sso', '/forgot-password', '/set-password', '/auth/2fa'];

const isSafe = (path: string): boolean =>
  path.startsWith('/') && !path.startsWith('//') && !AUTH_PATHS.some((p) => path.startsWith(p));

export const saveReturnTo = (path: string) => sessionStorage.setItem(STORAGE_KEY, path);

export const consumeReturnTo = (): string => {
  const returnTo = sessionStorage.getItem(STORAGE_KEY);
  sessionStorage.removeItem(STORAGE_KEY);
  return returnTo && isSafe(returnTo) ? returnTo : '/';
};
